export default __webpack_public_path__ + "static/clients04-afc38968cbc7f43f7b312dd06dd4b1b0.svg";